<mat-accordion>
  <mat-expansion-panel class="mt-5" [expanded]="true" hideToggle="true" #availabilityAccordion>
    <mat-expansion-panel-header
    >
      <mat-panel-title>
        <span class="svg-icon svg-icon-3x">
          <span [inlineSVG]="AvailabilityIconPath"></span>
        </span>
        <h3 class="text-dark font-weight-bold ml-3">
          <span class="mr-3">Availability</span>
          <br />
          <span class="text-muted font-weight-light font-size-sm"
            >View and update provider availability timing</span
          >
        </h3>
      </mat-panel-title>
      <mat-panel-description class="expansion_right">
        <button
          *ngIf="!availabilityAccordion.expanded"
          mat-icon-button
          class="btn btn-sm btn-default btn-text-primary btn-icon mt-1"
          color="primary"
        >
          <span class="material-icons"> keyboard_arrow_down </span>
        </button>

        <button
          *ngIf="availabilityAccordion.expanded"
          mat-icon-button
          class="btn btn-sm btn-default btn-text-primary btn-icon mt-1"
          color="primary"
        >
          <span class="material-icons"> keyboard_arrow_up </span>
        </button>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="mt-6"></div>

    <ng-container>
      <form
        class="form"
        #availabilityForm="ngForm"
        (ngSubmit)="availabilityForm.form.valid && onSubmit()"
        novalidate
      >
        <mat-card>
          <h4 class="font-weight-bold">Availability Details</h4>
        </mat-card>

        <mat-card
          class="mt-5"
          *ngFor="let item of availabilityFormValue; index as j"
        >
          <div class="row">
            <div
              class="col-md-12 font-weight-bold"
              [ngClass]="{
                'pb-5 border-bottom': availabilityFormValue[j]['day']
              }"
            >
              <mat-checkbox
                class="example-margin font-size-h5"
                name="weekdays{{ j }}"
                [value]="item.text"
                [(ngModel)]="availabilityFormValue[j]['day']"
                >{{ item.text }}</mat-checkbox
              >
            </div>
          </div>

          <div
            *ngIf="timeSlots"
            [ngClass]="{ 'pt-5': availabilityFormValue[j]['day'] }"
          >
            <mat-accordion *ngIf="availabilityFormValue[j]['day']">
              <mat-expansion-panel
                hideToggle="true"
                class="mat-accordion-a2z"
                #availabilityAccordion
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 class="text-dark font-size-h6 font-weight-bold ml-3">
                      Time Slots <br />
                      <span
                        class="text-muted font-weight-light font-size-sm mt-1"
                        >Add & delete time slot information</span
                      >
                    </h3>
                  </mat-panel-title>
                  <mat-panel-description class="expansion_right">
                    <button
                      *ngIf="!availabilityAccordion.expanded"
                      mat-icon-button
                      class="btn btn-sm btn-default btn-text-primary btn-icon mt-1"
                      color="primary"
                    >
                      <span class="material-icons"> keyboard_arrow_down </span>
                    </button>

                    <button
                      *ngIf="availabilityAccordion.expanded"
                      mat-icon-button
                      class="btn btn-sm btn-default btn-text-primary btn-icon mt-1"
                      color="primary"
                    >
                      <span class="material-icons"> keyboard_arrow_up </span>
                    </button>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="row" *ngIf="availabilityFormValue[j]['day']">
                  <!-- *ngIf="availabilityFormValue[j]['day']" -->
                  <!-- Time Slots -->
                  <ng-container>
                    <div class="col-md-12">
                      <div class="row">
                        <ng-container>
                          <div class="col-md-3">
                            <div class="form-group">
                              <mat-form-field class="example-full-width">
                                <input
                                  matInput
                                  placeholder="From Time"
                                  [disabled]="!availabilityFormValue[j]['day']"
                                  type="time"
                                  name="from_time{{ j }}"
                                  [(ngModel)]="from_time[j]"
                                  autocomplete="off"
                                />
                                <mat-error *ngIf=""></mat-error>
                              </mat-form-field>
                            </div>
                          </div>

                          <div class="col-md-3">
                            <div class="form-group">
                              <mat-form-field class="example-full-width">
                                <input
                                  matInput
                                  placeholder="To Time"
                                  [disabled]="!availabilityFormValue[j]['day']"
                                  type="time"
                                  name="to_time{{ j }}"
                                  [(ngModel)]="to_time[j]"
                                  autocomplete="off"
                                />
                                <mat-error *ngIf=""></mat-error>
                              </mat-form-field>
                            </div>
                          </div>

                          <div class="col-md-3">
                            <a
                              mat-icon-button
                              class="btn btn-sm btn-default btn-text-primary btn-icon mt-8"
                              color="primary"
                              (click)="addTimeSlots(j)"
                            >
                              <span class="material-icons">
                                add_circle_outline
                              </span>
                            </a>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <mat-chip-list aria-label="Time selection">
                      <mat-chip
                        class="mat-standard-chip-secondary"
                        *ngFor="let slot of item.timing.slot; index as k"
                        selected
                        color="default"
                      >
                        {{
                          todayDate + ' ' + slot.from_time | date: 'h:mm a'
                        }}
                        -
                        {{ todayDate + ' ' + slot.to_time | date: 'h:mm a' }}
                        <a
                          mat-icon-button
                          class="btn btn-sm btn-text-secondary btn-icon ml-3"
                          color="secondary"
                          (click)="removeTimeSlots(j, k)"
                        >
                          <span class="material-icons"> highlight_off </span>
                        </a>
                      </mat-chip>
                    </mat-chip-list>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>

          <div
            *ngIf="queueSlots"
            [ngClass]="{ 'pt-5': availabilityFormValue[j]['day'] }"
          >
            <mat-accordion *ngIf="availabilityFormValue[j]['day']">
              <mat-expansion-panel
                hideToggle="true"
                class="mat-accordion-a2z"
                #availabilityAccordion
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h3 class="text-dark font-size-h6 font-weight-bold ml-3">
                      Queue Slots <br />
                      <span
                        class="text-muted font-weight-light font-size-sm mt-1"
                        >Add & delete queue slot information</span
                      >
                    </h3>
                  </mat-panel-title>
                  <mat-panel-description class="expansion_right">
                    <button
                      *ngIf="!availabilityAccordion.expanded"
                      mat-icon-button
                      class="btn btn-sm btn-default btn-text-primary btn-icon mt-1"
                      color="primary"
                    >
                      <span class="material-icons"> keyboard_arrow_down </span>
                    </button>

                    <button
                      *ngIf="availabilityAccordion.expanded"
                      mat-icon-button
                      class="btn btn-sm btn-default btn-text-primary btn-icon mt-1"
                      color="primary"
                    >
                      <span class="material-icons"> keyboard_arrow_up </span>
                    </button>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="row">
                  <ng-container>
                    <div class="col-md-12">
                      <div class="row">
                        <ng-container>
                          <div class="col-md-3">
                            <div class="form-group">
                              <mat-form-field class="example-full-width">
                                <input
                                  matInput
                                  placeholder="From Time"
                                  [disabled]="!availabilityFormValue[j]['day']"
                                  type="time"
                                  name="from_time_queue{{ j }}"
                                  [(ngModel)]="from_time_queue[j]"
                                  autocomplete="off"
                                />
                                <mat-error *ngIf=""></mat-error>
                              </mat-form-field>
                            </div>
                          </div>

                          <div class="col-md-3">
                            <div class="form-group">
                              <mat-form-field class="example-full-width">
                                <input
                                  matInput
                                  placeholder="To Time"
                                  [disabled]="!availabilityFormValue[j]['day']"
                                  type="time"
                                  name="to_time_queue{{ j }}"
                                  [(ngModel)]="to_time_queue[j]"
                                  autocomplete="off"
                                />
                                <mat-error *ngIf=""></mat-error>
                              </mat-form-field>
                            </div>
                          </div>

                          <div class="col-md-3">
                            <a
                              mat-icon-button
                              class="btn btn-sm btn-default btn-text-primary btn-icon mt-8"
                              color="primary"
                              (click)="addQueueSlots(j)"
                            >
                              <span class="material-icons">
                                add_circle_outline
                              </span>
                            </a>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <div class="row" *ngIf="availabilityFormValue[j]['day']">
                  <div class="col-md-12">
                    <mat-chip-list aria-label="Queue Time selection">
                      <mat-chip
                        class="mat-standard-chip-primary"
                        *ngFor="let queue of item.timing.queue; index as k"
                        selected
                        color="default"
                        >{{
                          todayDate + ' ' + queue.from_time | date: 'h:mm a'
                        }}
                        -
                        {{ todayDate + ' ' + queue.to_time | date: 'h:mm a' }}

                        <a
                          mat-icon-button
                          class="btn btn-sm btn-text-primary btn-icon ml-3"
                          color="primary"
                          (click)="removeQueueSlots(j, k)"
                        >
                          <span class="material-icons"> highlight_off </span>
                        </a>
                      </mat-chip>
                    </mat-chip-list>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </mat-card>

        <div class="mt-10" style="text-align: center">
          <button
            mat-raised-button
            class="btn btn-primary"
            color="primary"
            type="submit"
            [disabled]="!availabilityForm.form.valid"
          >
            Save
          </button>
          &nbsp;&nbsp;&nbsp;
          <a
            mat-raised-button
            (click)="cancelClick()"
            class="btn btn-light-primary btn-bold"
          >
            Cancel
          </a>
        </div>
      </form>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>
